import React from 'react';
import { Section } from '../Styled/Containers';


import Welcome from './Welcome';

const Home = () => {
    return (
        <Section id='home'>
            <Welcome />
        </Section>
    )
}

export default Home;